import { fetchQGDData } from './FetchGeoData';
import { fetchStateBoundaries } from './FetchStateBoundaries';
import { fetchCountyBoundaries } from './FetchCountyBoundaries';
import { fetchCensusTractBoundaries } from './FetchCensusTractBoundaries';
import { fetchCensusTractNRIData } from './FetchCensusTractNRIData';
import { fetchHousingMarketData } from './FetchHousingMarketData';
import { FetchCensusHousingIncomeInfo } from './FetchCensusHousingIncomeInfo';
import { fetchAdditionalGeoData } from './FetchAdditionalGeoData';
import { QGDStorage } from './QGDStorage';
import SampleFemaData from './SampleData/state_fema_data.json';


export const fetchAllBoundaryData = async (address) => {
    console.log('Raw address received:', address);
    // console.log('Stringified address:', JSON.stringify(address));
    console.log('Address properties:', {
        zip_code: address.zip_code,
        fips: address.fips,
        state_short_name: address.state_short_name,
        census_tract: address.census_tract
    });
    // Get the complete current state of QGD data
    const currentQGD = JSON.parse(localStorage.getItem('qgd')) || { zip: {}, fips: {}, state: {}, census_tract: {} };

    try {
        console.log('About to fetch census tract data for:', address.census_tract);
        
        // Fetch all data in parallel
        const [
            qgdResult,
            stateBoundary,
            countyBoundary,
            // censusTractBoundary,
            // censusTractNRI,
            // housingMarketDataFips,
            // housingMarketDataZip,
            censusHousingIncomeInfo,
            additionalGeoData
        ] = await Promise.all([
            fetchQGDData(address),
            fetchStateBoundaries(address.state_short_name),
            fetchCountyBoundaries(address.fips),
            // fetchCensusTractBoundaries(address.census_tract).catch(error => {
            //     console.error('Census Tract Boundary fetch failed:', error);
            //     return null;
            // }),
            // fetchCensusTractNRIData(address.census_tract).catch(error => {
            //     console.error('Census Tract NRI fetch failed:', error);
            //     return null;
            // }),
            // fetchHousingMarketData('fips', address.fips).catch(error => {
            //     console.error('FIPS Housing Market Data fetch failed:', error);
            //     return null;
            // }),
            // fetchHousingMarketData('zip', address.zip_code).catch(error => {
            //     console.error('ZIP Housing Market Data fetch failed:', error);
            //     return null;
            // }),
            FetchCensusHousingIncomeInfo(address.zip_code, address.fips, address.census_tract).catch(error => {
                console.error('Census Housing Income Info fetch failed:', error);
                return null;
            }),
            fetchAdditionalGeoData(address)
        ]);

        console.log('Fetch results:', {
            qgdResult: !!qgdResult,
            stateBoundary: !!stateBoundary,
            countyBoundary: !!countyBoundary,
            // censusTractBoundary: !!censusTractBoundary,
            // censusTractNRI: !!censusTractNRI,
            // housingMarketDataFips: !!housingMarketDataFips,
            // housingMarketDataZip: !!housingMarketDataZip,
            censusHousingIncomeInfo: !!censusHousingIncomeInfo,
            additionalGeoData: !!additionalGeoData
        });
        console.log('additionalGeoData FETCHED', additionalGeoData)

        // FOR TESTING THE DATA
        // console.log('SAMPLE FEMA DATA', SampleFemaData)
        // additionalGeoData.fema_data_state = SampleFemaData;
        console.log('STATE FEMA DATA', additionalGeoData.fema_data_state)

        // First, merge the QGD data
        const updatedQGD = {
            zip: {
                ...currentQGD.zip,
                ...(qgdResult?.zip || {}),
                [address.zip_code]: {
                    ...(currentQGD.zip[address.zip_code] || {}),
                    ...(qgdResult?.zip[address.zip_code] || {}),
                    ...(additionalGeoData?.housing_market_data_zip || {}),
                    census_income_data: censusHousingIncomeInfo?.zip || {}
                }
            },
            fips: {
                ...currentQGD.fips,
                ...(qgdResult?.fips || {}),
                [address.fips]: {
                    ...(currentQGD.fips[address.fips] || {}),
                    ...(qgdResult?.fips[address.fips] || {}),
                    ...(countyBoundary ? { geometry: countyBoundary.geometry } : {}),
                    ...(additionalGeoData?.fema_data_fips ? { fema_data: additionalGeoData?.fema_data_fips } : {}),
                    ...(additionalGeoData?.housing_market_data_fips || {}),
                    census_income_data: censusHousingIncomeInfo?.fips || {},
                }
            },
            state: {
                ...currentQGD.state,
                ...(qgdResult?.state || {}),
                [address.state_short_name]: {
                    ...(currentQGD.state[address.state_short_name] || {}),
                    ...(qgdResult?.state[address.state_short_name] || {}),
                    ...(stateBoundary ? { geometry: stateBoundary.geometry } : {}),
                    fema_data: additionalGeoData?.fema_data_state || {}
                }
            },
            census_tract: {
                ...currentQGD.census_tract,
                [address.census_tract]: {
                    ...(currentQGD.census_tract?.[address.census_tract] || {}),
                    ...(additionalGeoData?.census_tract_nri || {}),
                    ...(additionalGeoData?.census_tract_geometry || {}),
                    census_income_data: censusHousingIncomeInfo?.tract || {}
                }
            }
        };

        console.log('additionalGeoData FETCHED', additionalGeoData)

        console.log('Updated QGD:', updatedQGD); // Debug log

        // Save the properly merged data (existing localStorage logic)
        // localStorage.setItem('qgd', JSON.stringify(updatedQGD));

        // Save to IndexedDB with fresh objects for each geography
        try {
            // Save ZIP data
            if (address.zip_code) {
                const zipData = {
                    ...(qgdResult?.zip[address.zip_code] || {}),
                    ...(additionalGeoData?.housing_market_data_zip || {}),
                    census_income_data: censusHousingIncomeInfo?.zip || {}
                };
                await QGDStorage.setData('zip', address.zip_code, zipData);
            }

            // Save FIPS data
            if (address.fips) {
                const fipsData = {
                    ...(qgdResult?.fips[address.fips] || {}),
                    ...(countyBoundary ? { geometry: countyBoundary.geometry } : {}),
                    ...(additionalGeoData?.housing_market_data_fips || {}),
                    census_income_data: censusHousingIncomeInfo?.fips || {},
                    fema_data: additionalGeoData?.fema_data || {}
                };
                await QGDStorage.setData('fips', address.fips, fipsData);
            }

            // Save state data
            if (address.state_short_name) {
                const stateData = {
                    ...(qgdResult?.state[address.state_short_name] || {}),
                    ...(stateBoundary ? { geometry: stateBoundary.geometry } : {}),
                    fema_data: additionalGeoData?.fema_data_state || {}
                };
                await QGDStorage.setData('state', address.state_short_name, stateData);
            }

            // Save census tract data
            if (address.census_tract) {
                const tractData = {
                    ...(additionalGeoData?.census_tract_nri || {}),
                    ...(additionalGeoData?.census_tract_geometry || {}),
                    census_income_data: censusHousingIncomeInfo?.tract || {}
                };
                await QGDStorage.setData('census_tract', address.census_tract, tractData);
            }
        } catch (error) {
            console.error('Failed to save to IndexedDB:', error);
            // Don't throw - we still have localStorage data
        }

        return {
            qgdData: qgdResult,
            stateBoundary,
            countyBoundary,
            additionalGeoData,
            censusHousingIncomeInfo,
            // censusTractBoundary,
            // censusTractNRI
        };
    } catch (error) {
        console.error('Error in fetchAllBoundaryData:', error);
        throw error;
    }
}; 